module.exports = __webpack_public_path__ + "img/1fe713d.jpg";